import loadable from '@loadable/component';
export const manifest = {
  CarouselCards: {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "CarouselCards";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "CarouselCards" */
          './carousel-cards-mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./carousel-cards-mobile");
            }

            return eval('require.resolve')("./carousel-cards-mobile");
          }

        }, {
          resolveComponent: mod => mod.CarouselCardsMobile
        })
      }
    }
  },
  Carousel: {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "CarouselMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "CarouselMobile" */
          './carousel-mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./carousel-mobile");
            }

            return eval('require.resolve')("./carousel-mobile");
          }

        }, {
          resolveComponent: mod => mod.CarouselMobile
        })
      }
    }
  }
};